import { render } from "./Footer.vue?vue&type=template&id=354b61a2&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=354b61a2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-354b61a2"]])

export default __exports__